import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import * as React from 'react'

import {generateClassicUILinkWithQuery} from '../../../../../selectors'
import type {AgentPoolId} from '../../../../../types'
import {resolveRelative} from '../../../../../utils/url'

import styles from './EditInClassicUILink.css'

function EditInClassicUILink({
  agentPoolId,
  children,
  className = '',
}: {
  agentPoolId: AgentPoolId
  children: React.ReactNode
  className?: string
}): React.ReactElement {
  return (
    <Button
      className={classNames(styles.editButton, className)}
      href={generateClassicUILinkWithQuery(
        resolveRelative('/agents.html'),
        {
          tab: 'agentPools',
        },
        String(agentPoolId),
      )}
      data-test={'edit-in-old-ui-link'}
    >
      {children}
    </Button>
  )
}

export default EditInClassicUILink
